import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "slide-tall-add" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.83301 18.3337C4.4523 18.3337 3.33301 17.2144 3.33301 15.8337V4.16699C3.33301 2.78628 4.4523 1.66699 5.83301 1.66699H14.1663C15.5471 1.66699 16.6663 2.78628 16.6663 4.16699V15.8337C16.6663 17.2144 15.5471 18.3337 14.1663 18.3337H5.83301ZM7.49967 9.16699C7.03944 9.16699 6.66634 9.54009 6.66634 10.0003C6.66634 10.4606 7.03944 10.8337 7.49967 10.8337H9.16634V12.5003C9.16634 12.9606 9.53944 13.3337 9.99967 13.3337C10.4599 13.3337 10.833 12.9606 10.833 12.5003V10.8337H12.4997C12.9599 10.8337 13.333 10.4606 13.333 10.0003C13.333 9.54009 12.9599 9.16699 12.4997 9.16699H10.833V7.50033C10.833 7.04009 10.4599 6.66699 9.99967 6.66699C9.53944 6.66699 9.16634 7.04009 9.16634 7.50033V9.16699H7.49967Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }